module.exports = __webpack_public_path__ + "static/media/PLUS Gas Fees@2x.3cbe858e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/driverpolicy-images/PLUS Gas Fees@2x.png
// module id = 1333
// module chunks = 0